// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export class GetAsyncEngagements {
  conversationId: string;
  chatId: string;
}
